import React from 'react';
import { IconWrapper, StyledIcon } from './styles';

interface IconProps {
  IconComponent: React.ComponentType;
}

export const HeadIconItemAddToCart: React.FC<IconProps> = ({ IconComponent }) => {
  return (
    <IconWrapper>
       <StyledIcon as={IconComponent} />
    </IconWrapper>
  );
};